module.exports = __webpack_public_path__ + "static/media/gallery.b6ed03e4.svg";